import { render, staticRenderFns } from "./penolakan.vue?vue&type=template&id=44d182e3"
import script from "./penolakan.vue?vue&type=script&lang=js"
export * from "./penolakan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports